export default "__VITE_ASSET__Cs4pRleF__"